import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-alert-descartar-alteracoes',
    templateUrl: './alert-descartar-alteracoes.component.html',
    styleUrls: ['./alert-descartar-alteracoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertDescartarAlteracoesComponent {
  @Input()
  show = false;
  @Output()
  cancelouDescarte  = new EventEmitter <boolean> ();

  @Output()
  confirmouDescarte = new EventEmitter <boolean>()

  constructor() { }

  cancelar() {
    this.cancelouDescarte.emit(false);
  }
  descartar() {
    this.confirmouDescarte.emit(true);
  }
}
